import React, { useState } from "react";

import mediaImg from "../../assets/mediaenter.png";
import bannerImg from "../../assets/WEBINAR-RPA-banner.jpg";

import { FaRobot } from "react-icons/fa";
import { MdOutlineComputer } from "react-icons/md";

const styles = `
  .me-header {
    display: flex;
    height: 110px;
    border-top: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
  }

  .me-header-left {
    flex: 1.5;
    position: relative;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    padding: 0 20px;
  }

  .me-header-overlay {
    position: absolute;
    inset: 0;
    background: rgba(47, 183, 164, 0.7);
  }

  .me-header-badge {
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    background: rgba(0, 0, 0, 0.15);
    padding: 14px 22px;
    border-radius: 6px;
    color: #fff;
    width: 100%;
    max-width: 520px;
    box-sizing: border-box;
  }

  .me-header-icon-box {
    width: 36px;
    height: 36px;
    min-width: 36px;
    background: #1f7f73;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .me-header-badge span:first-of-type {
    font-size: 14px;
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .me-header-badge .me-arrow {
    margin-left: auto;
    font-size: 24px;
    flex-shrink: 0;
  }

  .me-header-right {
    flex: 1;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .me-triangle-left {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg, #2fb7a4 30%, #2f6f9f 60%, #2f4a7f);
    clip-path: polygon(0 0, 60% 0, 0 100%);
  }

  .me-triangle-right {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg, #2fb7a4 30%, #2f6f9f 60%, #2f4a7f);
    clip-path: polygon(100% 0, 100% 100%, 40% 100%);
  }

  .me-title-group {
    display: flex;
    align-items: center;
    gap: 12px;
    z-index: 1;
  }

  .me-title-group h2 {
    margin: 0;
    font-size: 30px;
    font-weight: 600;
    color: #243b64;
  }

  .me-main {
    display: flex;
    padding: 60px 80px;
    gap: 60px;
    align-items: center;
  }

  .me-img-wrapper {
    flex: 1;
  }

  .me-img-wrapper img {
    width: 100%;
    max-width: 650px;
    display: block;
  }

  .me-accordion {
    flex: 1.2;
  }

  .me-accordion-item {
    margin-bottom: 18px;
  }

  .me-accordion-header {
    background: linear-gradient(90deg, #2fb7a4 0%, #2f6f9f 60%, #2f4a7f 100%);
    color: #f4f7fb;
    padding: 8px 24px;
    cursor: pointer;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;
    user-select: none;
  }

  .me-accordion-arrow {
    font-size: 22px;
    flex-shrink: 0;
    margin-left: 12px;
  }

  .me-accordion-body {
    padding: 20px;
    color: #555;
  }

  /* ── Tablet (≤ 1024px) ── */
  @media (max-width: 1024px) {
    .me-header {
      height: auto;
      min-height: 90px;
    }

    .me-header-badge {
      max-width: 100%;
      padding: 10px 14px;
    }

    .me-main {
      padding: 40px 40px;
      gap: 40px;
    }

    .me-title-group h2 {
      font-size: 26px;
    }
  }

  /* ── Small tablet / large phone (≤ 768px) ── */
  @media (max-width: 768px) {
    .me-header {
      flex-direction: column;
      height: auto;
    }

    .me-header-left {
      flex: none;
      min-height: 70px;
      padding: 12px 16px;
    }

    .me-header-right {
      flex: none;
      min-height: 70px;
      padding: 12px 16px;
    }

    .me-triangle-left,
    .me-triangle-right {
      width: 50px;
    }

    .me-title-group h2 {
      font-size: 22px;
    }

    .me-main {
      flex-direction: column;
      padding: 30px 20px;
      gap: 30px;
    }

    .me-img-wrapper {
      width: 100%;
    }

    .me-img-wrapper img {
      max-width: 100%;
    }

    .me-accordion {
      width: 100%;
    }
  }

  /* ── Mobile (≤ 480px) ── */
  @media (max-width: 480px) {
    .me-header {
      flex-direction: column;
      height: auto;
    }

    .me-header-left {
      min-height: 60px;
      padding: 10px 12px;
    }

    .me-header-badge {
      padding: 10px 12px;
      gap: 8px;
    }

    .me-header-badge span:first-of-type {
      font-size: 12px;
    }

    .me-header-icon-box {
      width: 30px;
      height: 30px;
      min-width: 30px;
    }

    .me-header-right {
      min-height: 60px;
      padding: 10px 12px;
    }

    .me-triangle-left,
    .me-triangle-right {
      width: 36px;
    }

    .me-title-group h2 {
      font-size: 16px;
    }

    .me-title-group svg {
      font-size: 24px !important;
    }

    .me-main {
      padding: 20px 12px;
      gap: 20px;
    }

    .me-accordion-header {
      font-size: 13px;
      padding: 8px 14px;
    }

    .me-accordion-arrow {
      font-size: 18px;
    }

    .me-accordion-body {
      padding: 14px 12px;
      font-size: 14px;
    }
  }

  /* ── Extra small (≤ 360px) ── */
  @media (max-width: 360px) {
    .me-title-group h2 {
      font-size: 13px;
    }

    .me-accordion-header {
      font-size: 12px;
      padding: 6px 10px;
    }
  }
`;

function MediaEntertainmentPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  const data = [
    {
      title: "1.Content Personalization",
      content:
        "Companies use ML and AI algorithms to analyse user behaviour and recommend personalized content."
    },
    {
      title: "2.Decision Automation",
      content:
        "Organizations use AI to generate reports and automate decision-making from analytics data."
    },
    {
      title: "3.Ad Targeting",
      content:
        "AI helps deliver targeted advertisements based on user interests and behavior."
    },
    {
      title: "4.Content Moderation",
      content:
        "AI detects harmful or inappropriate content and ensures platform safety."
    }
  ];

  return (
    <div>
      <style>{styles}</style>

      {/* ===== HEADER (UNCHANGED) ===== */}
      <div className="me-header">
        {/* LEFT */}
        <div
          className="me-header-left"
          style={{ backgroundImage: `url(${bannerImg})` }}
        >
          <div className="me-header-overlay" />

          <div className="me-header-badge">
            <div className="me-header-icon-box">
              <FaRobot style={{ color: "#fff", fontSize: "18px" }} />
            </div>

            <span>Artificial Intelligence - Use Cases</span>
            <span className="me-arrow">›</span>
          </div>
        </div>

        {/* RIGHT */}
        <div className="me-header-right">
          <div className="me-triangle-left" />
          <div className="me-triangle-right" />

          <div className="me-title-group">
            <MdOutlineComputer style={{ fontSize: "32px", color: "#2fb7a4" }} />

            <h2>Media & Entertainment</h2>
          </div>
        </div>
      </div>

      {/* ===== MAIN (FIXED TO OPERATIONS MEASUREMENTS) ===== */}
      <div className="me-main">
        {/* IMAGE */}
        <div className="me-img-wrapper">
          <img src={mediaImg} alt="" />
        </div>

        {/* ACCORDION */}
        <div className="me-accordion">
          {data.map((item, i) => (
            <div key={i} className="me-accordion-item">
              <div
                className="me-accordion-header"
                onClick={() => toggle(i)}
              >
                {item.title}
                <span className="me-accordion-arrow">
                  {openIndex === i ? "↑" : "⌄"}
                </span>
              </div>

              {openIndex === i && (
                <div className="me-accordion-body">{item.content}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default MediaEntertainmentPage;
